import { Converter, Occ, VariantOption } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ProductLine } from '../../../models'

@Injectable({ providedIn: 'root' })
export class VariantOptionToProductLineModelNormalizer implements Converter<Occ.VariantOption, ProductLine> {

  convert (source: Occ.VariantOption, target?: ProductLine) {
    return {
      ...target,
      code: source.code,
      regulatoryStatus: (source as any).regulatoryStatus,
      clinicalReferenceNumber: (source as any).clinicalReferenceNumber,
      name: (source as any).name,
      size: (source as any).size,
      components: (source as any).components,
      stamps: (source as any).stamps,
      userManuals: (source as any).userManuals,
      dataSheets: (source as any).dataSheets,
      priceData: source.priceData,
      hasPriceOnRequest: (source as any).priceOnRequest,
      productLine: (source as any).productLine?.entries
    } as ProductLine
  }
}

export const VARIANT_OPTION_TO_PRODUCT_LINE_NORMALIZER = new InjectionToken<Converter<VariantOption, ProductLine>>('VariantOptionToProductLineModelNormalizer')
